import React from 'react';
import { motion } from 'framer-motion';

const ProblemSection = () => {
  const problems = [
    "Leads varala → Marketing la lakhs spend panni waste panreenga?",
    "Customers message panraanga but timely reply panna mudiyala?", 
    "Staffs follow-up miss panraanga, sales poguthu competitors kitte?",
    "Payments track panna kashtam → offline + online confuse aaguthu?",
    "WhatsApp group la manual work nala tension aaguthu?"
  ];

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-2 lg:order-1"
          >
            <div className="relative">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759114057014-abdul%20with%20robo.webp"
                alt="Abdul with AI Robot - Business Problems"
                className="rounded-2xl shadow-2xl w-full h-64 sm:h-80 object-cover"
              />
              <div className="absolute inset-0 bg-red-500 bg-opacity-20 rounded-2xl"></div>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="order-1 lg:order-2"
          >
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-8">
              😓 Do You Face These Daily Problems?
            </h2>
            
            <div className="space-y-4 sm:space-y-6 mb-8">
              {problems.map((problem, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-start space-x-3 sm:space-x-4"
                >
                  <span className="text-red-500 text-xl sm:text-2xl mt-1">❌</span>
                  <p className="text-gray-200 text-lg sm:text-xl leading-relaxed">
                    {problem}
                  </p>
                </motion.div>
              ))}
            </div>
            
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              className="bg-red-600 bg-opacity-20 border border-red-400 rounded-xl p-4 sm:p-6"
            >
              <p className="text-red-300 text-lg sm:text-xl font-semibold text-center">
                👉 இவங்க தான் night-la unga <span className="text-red-400 font-bold">sleep kill panna problems</span>.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;